import { latLng } from 'leaflet'
import React, { useState, useEffect } from 'react'
import ContentBox from '../components/ContentBox'
import Header from '../components/home/Header';

export default function Legislacoes() {

  const googleDriveUrl = `https://drive.google.com/embeddedfolderview?id=${process.env.REACT_APP_LEGISLACOES_GOOGLEDRIVE_SHAREDID}#`;

  useEffect(() => {
    start();
  }, []);


  const start = async () => {
    handlerToggleMenu();
  }

  const handlerToggleMenu = () => {
    document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';
  }

  return (
    <>
      <Header>
        <h5 style={{ marginLeft: '20px', marginBottom: '-60px' }}> <i className='zmdi zmdi-accounts'></i> LEGISLAÇÕES  </h5>
      </Header>
      <ContentBox>
        <div className="row clearfix">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="card">
              <div className="header">
                <h2><i className='zmdi zmdi-file'></i> DOCUMENTOS RELACIONADOS <small> LEIS E DECRETOS  </small> </h2>
                <hr />
              </div>
              <iframe src={googleDriveUrl + 'list'} style={{ width: '100%', height: '300px', border: '0' }}></iframe>
            </div>
          </div>
        </div>
      </ContentBox>
    </>
  )
}
